import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

export const DatePickerField = ({ value, onChange, onBlur, label, error, ...props }) => {
  return (
    <DatePicker
      label={label}
      value={value || null}
      onChange={onChange}
      inputFormat="dd MMM yyyy"
      disableMaskedInput
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          onBlur={onBlur}
          error={!!error}
          sx={{
            width: 150,
            '& .MuiInputAdornment-root': { marginRight: '-2px' },
            '& .MuiSvgIcon-root': { fontSize: '1.2rem', opacity: 0.9 },
          }}
        />
      )}
      components={{
        OpenPickerIcon: CalendarMonthOutlinedIcon,
      }}
      {...props}
    />
  );
};

DatePickerField.displayName = 'DatePickerField';
